import { z } from 'zod'
import { atomWithSessionStorage } from '../useStorage/atomsWithStorages'
import { MFRM_UNIFY_VERTICAL_BAR_EXPANDED_KEY } from '../conventions'

export const verticalBarExpanded = atomWithSessionStorage(MFRM_UNIFY_VERTICAL_BAR_EXPANDED_KEY, false, z.boolean())
